// Per-deployment business identity. This is what changes when this template
// is deployed for a different pet grooming studio -- set via REACT_APP_*
// build-time env vars so onboarding a new customer never needs a code change.

export const BUSINESS_NAME = process.env.REACT_APP_BUSINESS_NAME || 'ZeeZo Pet Grooming Studio';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'info@zeezo.com';
// Digits only, with country code, no "+" (as required by wa.me links).
export const SUPPORT_WHATSAPP = process.env.REACT_APP_SUPPORT_WHATSAPP || '918424020105';
export const CURRENCY_CODE = process.env.REACT_APP_CURRENCY_CODE || 'INR';
export const CURRENCY_SYMBOL = process.env.REACT_APP_CURRENCY_SYMBOL || '₹';
// Country calling code (no "+") used to normalize phone numbers for wa.me links.
export const DEFAULT_COUNTRY_CODE = process.env.REACT_APP_DEFAULT_COUNTRY_CODE || '91';
export const TERMS_URL = process.env.REACT_APP_TERMS_URL || 'https://zeezo.com/terms';
// Replace /public/logo.webp and /public/logo.png with the new business's own
// logo when deploying for a different customer -- the path itself stays fixed.
export const LOGO_PATH = '/logo.webp';
